/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ColorTextInput/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'



/** @type {import('Simple/types.js').View} */
export default function ColorTextInput({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Leads/Content/Content/Settings/Content/Theme/PrimaryLight/ColorTextInput",
  onChange,
  isInvalid
  
}) {
let settingsThemeoverrideLightValueData = fromData.useDataValue({ viewPath,
context: 'settings',
path: 'themeOverride.light',
})
let settingsThemeoverrideLightIsValidData = fromData.useDataIsValid({ viewPath,
context: 'settings',
path: 'themeOverride.light',
validate: fromValidate.color,
})
let settingsThemeoverrideLightChangeData = fromData.useDataChange({ viewPath,
context: 'settings',
path: 'themeOverride.light',
})
  return (<React.Fragment
>
<TysiaInputField
  viewPath={`${viewPath}/TysiaInputField`}
 data="settings.themeOverride.light"
 value={settingsThemeoverrideLightValueData}
 onChange={settingsThemeoverrideLightChangeData}
 validate="/Data/validate.js color"
 invalid={!settingsThemeoverrideLightIsValidData}
/>
{children}
</React.Fragment>)
}